import { PaSubCategory } from './generated/types';
export const PaSubCategorySynthesis = [
    PaSubCategory.EnvironmentSynthesis,
    PaSubCategory.PositioningSynthesis,
    PaSubCategory.MeansSynthesis,
    PaSubCategory.Synthesis,
];
export const isSynthesis = (c) => !!PaSubCategorySynthesis.find(s => s === c);
//# sourceMappingURL=TypeUtils.js.map